"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var helpers_1 = require("./helpers");
var useSmartlinkComponent = function (prePaymentMethod, onPaymentSuccess, env) {
    var _a, _b;
    var iframeRef = (0, react_1.useRef)(null);
    var enviroment = env !== null && env !== void 0 ? env : (0, helpers_1.getEnviroment)((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) !== null && _b !== void 0 ? _b : "");
    var smartlinkOrigin = (0, helpers_1.urlStringToUrlObject)(helpers_1.SMARTLINK_BASE_URL[enviroment]);
    var _c = (0, react_1.useState)(null), rectangle = _c[0], setRectangle = _c[1];
    var sendMessageToIframe = (0, react_1.useCallback)(function (message) {
        var _a, _b;
        if (iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.current) {
            (_b = (_a = iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(message, smartlinkOrigin);
        }
    }, [smartlinkOrigin]);
    (0, react_1.useEffect)(function () {
        var handleMessage = function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var verbose, _a, quoteId, _b, success, payment_id, successPaymentData, rectangleData, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        verbose = true;
                        if (event.origin !== smartlinkOrigin) {
                            return [2 /*return*/];
                        }
                        if (!event.data.includes("startPrePaymentMethod")) return [3 /*break*/, 2];
                        _a = event.data.split(":"), quoteId = _a[1];
                        return [4 /*yield*/, prePaymentMethod(quoteId)];
                    case 1:
                        _b = _c.sent(), success = _b.success, payment_id = _b.payment_id;
                        sendMessageToIframe("paymentID:".concat(success ? payment_id : "invalid"));
                        _c.label = 2;
                    case 2:
                        if (event.data.includes("smartlinkPaymentSuccess")) {
                            successPaymentData = event.data.split(":").slice(1).join(":");
                            onPaymentSuccess(successPaymentData);
                        }
                        if (event.data.includes("ccChargePaymentSuccess")) {
                            sendMessageToIframe("submitStripeForm");
                        }
                        if (event.data.includes("ccChargePaymentError")) {
                        }
                        if (!event.data.includes("rectangle")) return [3 /*break*/, 6];
                        verbose = false;
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, JSON.parse(event.data)];
                    case 4:
                        rectangleData = _c.sent();
                        if (rectangleData.rectangle)
                            setRectangle(rectangleData.rectangle);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _c.sent();
                        console.error("Invalid rectangle", error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        if (verbose)
                            console.log("message from Iframe: ", event.data);
                        return [2 /*return*/];
                }
            });
        }); };
        window.addEventListener("message", handleMessage);
        return function () {
            window.removeEventListener("message", handleMessage);
        };
    }, [smartlinkOrigin, prePaymentMethod, sendMessageToIframe]);
    return {
        iframeRef: iframeRef,
        sendMessageToIframe: sendMessageToIframe,
        enviroment: enviroment,
        rectangle: rectangle,
    };
};
exports.default = useSmartlinkComponent;
